(function () {
  var ENDPOINT = '/apps/nyd';
  var PAGEVIEW_DELAY = 2000;
  var lastAdd = { productId: null, at: 0 };

  function generateId() {
    if (window.crypto && crypto.randomUUID) {
      return crypto.randomUUID();
    }

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  function getUserId() {
    var userId = localStorage.getItem('nuid');

    if (!userId) {
      userId = generateId();
      localStorage.setItem('nuid', userId);
    }

    return 'u_' + userId;
  }

  function getSessionId() {
    var sessionTimeout = 30 * 60 * 1000;
    var sessionId = localStorage.getItem('n_session_id');
    var lastActivity = parseInt(localStorage.getItem('n_session_last_activity') || '0', 10);
    var now = Date.now();

    if (!sessionId || now - lastActivity > sessionTimeout) {
      sessionId = generateId();
      localStorage.setItem('n_session_id', sessionId);
    }

    localStorage.setItem('n_session_last_activity', now.toString());

    return 's_' + sessionId;
  }

  function send(payload) {
    var body = JSON.stringify(payload);

    if (navigator.sendBeacon) {
      navigator.sendBeacon(ENDPOINT, body);
      return;
    }

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: body,
      keepalive: true
    });
  }

  function buildPayload(productId, source) {
    return {
      user_id: getUserId(),
      session_id: getSessionId(),
      productId: productId,
      timestamp: Date.now(),
      page_url: location.pathname,
      source: source,
      referrer: document.referrer
    };
  }

  function trackProductView() {
    if (document.visibilityState !== 'visible') return;

    var productId = window.nydProductId;
    if (!productId) return;

    send(buildPayload(productId, 'pageview'));
  }

  function trackAddToCart(event) {
    var product = event && event.detail && event.detail.product;
    if (!product) return;

    var productId = product.product_id || window.nydProductId;
    if (!productId) return;

    var now = Date.now();
    if (lastAdd.productId === productId && now - lastAdd.at < 1000) return;

    lastAdd.productId = productId;
    lastAdd.at = now;

    send(buildPayload(productId, 'addtocart'));
  }

  function init() {
    setTimeout(trackProductView, PAGEVIEW_DELAY);
    document.addEventListener('ajaxProduct:added', trackAddToCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
